import React from "react";
import { FaClock, FaNetworkWired, FaShieldAlt, FaTools } from "react-icons/fa";
import classes from "./Section2.module.css";
import { Link } from "react-router-dom";

export default function Section2() {
  const features = [
    {
      icon: <FaClock />,
      title: "24/7 IT Support",
      desc: "Round-the-clock hardware and network assistance.",
    },
    {
      icon: <FaNetworkWired />,
      title: "Optimized Networks",
      desc: "Secure, high-performance connectivity.",
    },
    {
      icon: <FaShieldAlt />,
      title: "Data & Hardware Security",
      desc: "Protect your IT systems effectively.",
    },
    {
      icon: <FaTools />,
      title: "Expert Maintenance",
      desc: "Professional servicing to maximize uptime.",
    },
  ];

  return (
    <div className={classes.section2Wrapper}>
      <div className={classes.section2Container}>
        {/* Image */}
        <div className={classes.section2image}>
          <img
            src="/img/home-img/section-2/about-img.webp"
            alt="Prime Cloud Systems IT Solutions"
          />
        </div>

        {/* Text */}
        <div className={classes.section2Text}>
          <div className={classes.highLightedText}>
            <span>About Prime Cloud Systems</span>
          </div>

          <h2>Reliable IT Hardware & Networking Solutions</h2>

          <p>
            Prime Cloud Systems delivers high-quality IT hardware, networking
            equipment, and maintenance solutions for businesses, IT
            professionals, and home users. We help optimize system performance,
            enhance security, and reduce downtime.
          </p>

          <p>
            With our expertise in IT infrastructure and hardware lifecycle
            management, we provide actionable solutions that empower your
            business to operate efficiently and securely.
          </p>

          {/* Features 2x2 */}
          <div className={classes.featuresGrid}>
            {features.map((feature, idx) => (
              <div className={classes.featureItem} key={idx}>
                <div className={classes.featureIcon}>{feature.icon}</div>
                <div className={classes.featureContent}>
                  <h4>{feature.title}</h4>
                  <p>{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* About Us Button */}
          <div className={classes.aboutUsBtn}>
            <Link to={"/about-us"}>Learn More About Us</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
